
import StyleProvider from '@/StyleProvider.vue';
import TheApp from './TheApp.vue';
import VModal from 'vue-js-modal';
import Vue, { PropType } from 'vue';
import i18n from '@/i18n';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { mapActions, mapState, PiniaVuePlugin } from 'pinia';
import { useStore as useAuthStore } from '@/stores/auth';
import { useStore as useLangStore } from '@/stores/lang';
import { SupportedLangCodes } from '../../constants/languageCodes';

Vue.use(PiniaVuePlugin);
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

import { pinia } from '@/pinia';

export default Vue.extend({
  components: {
    StyleProvider,
    TheApp,
  },
  props: {
    languageCode: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'en',
      validator: isValidLanguageValidator,
    },
    sapCustomerId: {
      type: String,
      required: true,
    },
    tok: {
      type: String,
      required: true,
    },
    env: {
      type: String,
      default: 'myAccount',
      required: true,
    },
    sapCustomerEmail: {
      type: String,
      required: false,
      default: '',
    },
    region: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    ...mapState(useLangStore, ['languageInUse']),
    ...mapState(useAuthStore, ['isTokValid']),
  },
  watch: {
    isTokValid(newValue) {
      if (!newValue) {
        this.$emit('token-invalid-or-expired');
      }
    },

    async tok(newValue) {
      if (newValue !== '') {
        this.setTok(this.tok);
        await this.setDefaultTranslations();
      }
    },
  },
  async mounted() {
    this.setLanguageLocale(this.languageCode);
    this.setSapCustomerId(this.sapCustomerId);
    this.setTok(this.tok);
    await this.setDefaultTranslations();
    this.$modal.show('logo-library-modal');
  },
  methods: {
    ...mapActions(useLangStore, [
      'setLanguageLocale',
      'setDefaultTranslations',
    ]),
    ...mapActions(useAuthStore, ['setSapCustomerId', 'setTok']),
  },
  i18n,
  pinia,
});
